import React from 'react';
import { View, TouchableOpacity, StyleSheet } from 'react-native';
import { Text } from '@/components/common/text';
import { useMarketplaceColors } from '@/constants/residents/marketplaceColors';

interface RadioButtonProps {
  selected: boolean;
  onPress: () => void;
  label: string;
  disabled?: boolean;
}

/**
 * Radio Button component matching Figma design
 * Reusable component for radio button selection in forms
 */
export const RadioButton: React.FC<RadioButtonProps> = ({
  selected,
  onPress,
  label,
  disabled = false,
}) => {
  const MARKETPLACE_COLORS = useMarketplaceColors();

  return (
    <TouchableOpacity
      style={styles.radioRow}
      onPress={onPress}
      activeOpacity={0.7}
      disabled={disabled}
    >
      <View style={styles.radioContainer}>
        {selected ? (
          <View style={[styles.radioSelected, { backgroundColor: MARKETPLACE_COLORS.radioSelected }]}>
            <View style={[styles.radioInner, { backgroundColor: MARKETPLACE_COLORS.radioInner }]} />
          </View>
        ) : (
          <View style={[styles.radioUnselected, { backgroundColor: MARKETPLACE_COLORS.checkboxBackground, borderColor: MARKETPLACE_COLORS.checkboxBorder }, disabled && styles.radioDisabled]} />
        )}
      </View>
      <Text style={[styles.radioLabel, { color: MARKETPLACE_COLORS.textPrimary }, disabled && styles.radioLabelDisabled]}>
        {label}
      </Text>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  radioRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 6,
    minHeight: 24,
  },
  radioContainer: {
    width: 20,
    height: 20,
    alignItems: 'center',
    justifyContent: 'center',
  },
  radioSelected: {
    width: 16,
    height: 16,
    borderRadius: 10,
    alignItems: 'center',
    justifyContent: 'center',
  },
  radioInner: {
    width: 8,
    height: 8,
    borderRadius: 6,
  },
  radioUnselected: {
    width: 16,
    height: 16,
    borderRadius: 4,
    borderWidth: 1,
  },
  radioDisabled: {
    opacity: 0.5,
  },
  radioLabel: {
    fontSize: 14,
    fontWeight: '500',
    lineHeight: 21,
  },
  radioLabelDisabled: {
    opacity: 0.5,
  },
});

export default RadioButton;
